import script from "./VVVEarlyPayWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVEarlyPayWallet.vue?vue&type=script&setup=true&lang=js"

import "./VVVEarlyPayWallet.vue?vue&type=style&index=0&id=d472bb94&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d472bb94"]])

export default __exports__